import { useTranslation } from 'react-i18next';
import { trDisplay } from '../../i18n';
import React from 'react';
import { HelpCircle } from 'lucide-react';
import { MobileTooltip } from '../ui/tooltip';

/**
 * SectionHeader - Reusable section header with optional icon and tooltip
 * Used across both Credit Lombard and SWR tabs
 */
export const SectionHeader = ({
  title,
  icon: Icon,
  iconBgColor = 'bg-slate-100',
  iconColor = 'text-slate-600',
  dotColor = 'bg-slate-500',
  tooltip,
  level = 2, // 2 for h2, 3 for h3
  className = '',
  showBorder = false,
}) => {
  useTranslation();
  const baseClasses = level === 2
    ? 'text-base sm:text-lg font-semibold text-slate-800'
    : 'text-sm sm:text-base font-semibold text-slate-700';

  const borderClasses = showBorder ? 'pt-4 border-t border-slate-200' : '';
  const sizeClasses = level === 2 ? 'gap-2 sm:gap-3' : 'gap-2';

  const HeadingTag = level === 2 ? 'h2' : 'h3';

  return (
    <HeadingTag className={`${baseClasses} flex items-center ${sizeClasses} ${borderClasses} ${className}`}>
      {trDisplay(Icon && (
        <div className={`p-1.5 sm:p-2 rounded-lg ${iconBgColor}`}>
          <Icon className={`h-4 w-4 sm:h-5 sm:w-5 ${iconColor}`} />
        </div>
      ))}
      {trDisplay(!Icon && dotColor && (
        <span className={`w-2 h-2 rounded-full ${dotColor}`}></span>
      ))}
      {trDisplay(title)}
      {trDisplay(tooltip && (
        <MobileTooltip
          content={typeof tooltip === 'string' ? <p className="text-sm">{trDisplay(tooltip)}</p> : tooltip}
          side="top"
        >
          <HelpCircle className="h-4 w-4 text-slate-400 cursor-help" />
        </MobileTooltip>
      ))}
    </HeadingTag>
  );
};

export default SectionHeader;
